import styled from 'styled-components';
export const RadioGroupWrapper = styled.div`
  & > div:last-child > label{
    margin-bottom: 0;
  }
`;